export default __webpack_public_path__ + "static/media/map@3x.b2beafc2.jpg";